// Vendors
import React, { useEffect, useState } from 'react';
import { Typography, Box } from '@mui/material';

// Components
import CustomerCard from '../../ContractDetail/CustomerCard/CustomerCard';

// Assets
import RightIcon from '@/assets/icons/dark-rightIcon.svg';
import DropIcon from '@/assets/icons/dropdown-icon.svg';

// Models and Store
import { Equipment } from '@/api/models/Contracts';
import { fetchEquipmentStart } from '@/store/features/equipments/equipmentSlice';
import { useAppDispatch, useAppSelector } from '@/hooks/storeHook';

/**
 * Component: ContractEquipment
 * Displays a list of contract-related equipment with expandable functionality.
 */
interface ContractEquipmentProps {
  handleContractListPopup: () => void;
  handleContractCustomerPopup: () => void;
  contractId: string | undefined;
  clientId: string | undefined;
  handleEquipmentPopup: (index: number) => void;
}
const ContractEquipment: React.FC<ContractEquipmentProps> = ({
  contractId,
  clientId,
  handleContractListPopup,
  handleContractCustomerPopup,
  handleEquipmentPopup,
}) => {
  const dispatch = useAppDispatch();
  const [isExpanded, setIsExpanded] = useState(true);

  const {
    equipments = [],
    loading,
    error,
  } = useAppSelector(
    (state: { equipments: { equipments: Equipment[]; loading: boolean; error: string | null } }) =>
      state.equipments,
  );

  useEffect(() => {
    dispatch(fetchEquipmentStart({ contractId: contractId, clientId : clientId }));
  }, [dispatch,contractId]);

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <div className="left-section">
      <CustomerCard
        handleContractListPopup={handleContractListPopup}
        handleContractCustomerPopup={handleContractCustomerPopup}
      />
      <div className="equipment-section">
        <Box
          className={`equipment-header ${isExpanded ? 'open-equipment' : 'closed-equipment'}`}
          onClick={toggleExpand}
        >
          <Typography className="header">
            Equipment: {loading ? '(Loading...)' : `(${equipments.length.toString()})`}
          </Typography>
          <img
            src={DropIcon}
            alt="dropdown arrow"
            className={`arrow ${isExpanded ? 'expanded' : ''}`}
          />
        </Box>

        {isExpanded && (
          <Box className="equipment-list">
            {error && <Typography color="error">{error}</Typography>}
            {!loading ? (
              equipments.map((equipment, index) => (
                <div
                  key={index}
                  className="equipment_wrap"
                  onClick={() => handleEquipmentPopup(index)}
                >
                  <Box className="equipment-item">
                    <Typography className="equipment-title">
                      {equipment.madeBy} {equipment.model}
                    </Typography>
                    {equipment.vin && 
                    <Typography className="equipment-vin">VIN: {equipment.vin}</Typography>
                    }
                  </Box>
                  <img src={RightIcon} alt="dropdown arrow" className="right-arrow" />
                </div>
              ))
            ) : (
              <Typography>No equipment found</Typography>
            )}
          </Box>
        )}
      </div>
    </div>
  );
};

export default ContractEquipment;
